import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, DataBlock, Grid } from '@fs/zion-ui'
import { PersonLink, TreePersonLink, UserLink } from '../../../app/Links'
import { isNullOrUndefined } from '../../../../util/Utils'
import { TreeIdCells } from './TreeIdBlock'

export default () => {}

export function ReligiousMessageSummary({ messageDetails, queueCachesState, queueCachesActions }) {
  const { t } = useTranslation()
  const personId = messageDetails?.personId
  const contributorId = messageDetails?.contributorId

  const personSummary = queueCachesState.personsCache[personId]
  const userSummary = queueCachesState.usersCache[contributorId]

  useEffect(() => {
    queueCachesActions.fetchPersonSummary(personId)
    queueCachesActions.fetchUserSummary(contributorId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isNullOrUndefined(personSummary) || isNullOrUndefined(userSummary)) {
    return null
  }

  return (
    <Grid>
      {/* Row */}
      <Cell columns={6}>
        <DataBlock
          heading={t('person.label', 'Person')}
          data={
            <>
              <PersonLink personId={personId} personName={personSummary?.summary?.name} showId newTab />
              <TreePersonLink personId={personId} treeIcon newTab />
            </>
          }
        />
      </Cell>
      <Cell columns={6}>
        <DataBlock
          heading={t('contributor', 'Contributor')}
          data={<UserLink userId={contributorId} userName={userSummary?.contactName} showId newTab />}
        />
      </Cell>

      <TreeIdCells treeId={messageDetails?.treeId} isResearcherTree={messageDetails?.researcherTree} />

      {/* Row */}
      {messageDetails?.unwantedTerm && (
        <Cell columns={12}>
          <DataBlock heading={t('queues.unwantedTerm', 'Unwanted Term')} data={messageDetails?.unwantedTerm} />
        </Cell>
      )}
      {messageDetails?.term && (
        <Cell columns={12}>
          <DataBlock heading={t('queues.term', 'Term')} data={messageDetails?.term} />
        </Cell>
      )}

      {/* Row */}
      <Cell columns={6}>
        <DataBlock heading={t('queues.unwantedText', 'Unwanted Text')} data={messageDetails?.unwantedText} />
      </Cell>
      <Cell columns={6}>
        <DataBlock heading={t('queues.changeLocation', 'Change Location')} data={messageDetails?.change} />
      </Cell>
    </Grid>
  )
}
